<template>
    <div v-if="resetPage" class="page-suprise-box relative">
        <img class="absolute top-14 left-4 z-20" src="@/assets/icon/ic-back-black.svg" alt="" @click="clickBack()">
        <div v-if="step == 1" class="relative z-10">
            <img :src="src1" alt="">
            <div class="absolute bottom-36 left-0 w-full">
                <div class="flex px-10 gap-4">
                    <div class="my-auto">
                        <img class="w-full" @click="openBox()" src="../assets/btn-surprise-box-spin.png" alt=""/>
                    </div>
                    <div class="my-auto">
                        <img class="w-full" @click="clickCondition()" src="../assets/btn-surprise-box-condition.png" alt=""/>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="step == 2">
            <img :src="src2" alt="">
        </div>
        <div v-if="step == 3">
            <img :src="src3" alt="">
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import ConfigManager from '@/config/ConfigManager.js';
import Account from '@/helper/AccountHelper.js';
import { UserLevel } from "@/core/UserLevel/UserLevelDetail.js";
import { CampaignType } from "@/helper/StaticValue.js";
// mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import SurpriseApi from '../service/SurpriseApi.js';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
import BzbsAddress from '@/core/Address/service/BzbsAddress.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
import CampaignModel from '@/core/Campaign/model/CampaignModel.js';
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

//config
import {
    RedeemConfigBuilder,
} from '@/core/Redeem/config/RedeemConfigBuilder.js';

export default {
    name: "Home",
    inject: ["AccountStore"],
    mixins: [ModalMixin, LocaleMixin, AuthStatusMixin],
    computed: {
        src1: function () {
            let timestamp = new Date().getTime()
            return require('../assets/2023-05-30-surprise-box-1.gif') + '?' + timestamp
        },
        src2: function () {
            let timestamp = new Date().getTime()
            return require('../assets/2023-05-30-surprise-box-2.gif') + '?' + timestamp
        },
        src3: function () {
            let timestamp = new Date().getTime()
            return require('../assets/2023-05-30-surprise-box-3.gif') + '?' + timestamp
        }
    },
    data: function() {
        return {
            step: 1,
            resetPage: true,
            campaignId: null,
            redeemConfigBuilder: new RedeemConfigBuilder(),
            dataSurprisrBox: null,
            isSerialLoading: false,
            redeemKey: null,
            conditionText: null,
            campaign: null,
            isVerifyCode: false,
        };
    },
    created: function() {
        this.resetPage = false;
        this.$nextTick(() => {
            this.resetPage = true;
        });
    },
    methods: {
        //#region mixin function
        onSetupModalCompleted: function() {
            this.initialSurpriseBoxModal();
            this.initialRedeemModal()
        },
        onAccountInit: async function() {
            let isGetProfileCustom = await this.AccountStore.methods.getProfileCustom();
            if (isGetProfileCustom) {
                this.checkVerifiedlaserno();
            } else {
                this.modalController.alertModal
                        .clearModal()
                        .setMsg("กรุณาลงทะเบียน S Plus+ ก่อนใช้งาน")
                        .setBtnOk("เข้าสู่ระบบ")
                        .show();

                this.modalController.alertModal
                        .onClickOk(() => {
                            let url = ConfigManager.getWebSofinUrl();
                            window.location.replace(url);
                        });
                this.modalController.alertModal
                        .onClickClose(() => {
                            this.$router.back()
                        });
            }
        },
        checkVerifiedlaserno: function() {
            this.userLevel = new UserLevel();
            let level = this.userLevel.getLevelVerifiedlaserno();
            if (!level) {
                this.modalController.confirmModal
                                    .clearModal()
                                    .setTag('verifiedlaserno')
                                    .setMsg(this.lbl.verify_laser_id.before_redeem)
                                    .setBtnOk(this.lbl.verify_laser_id.confirm_btn)
                                    .show()
                this.modalController.confirmModal.onClickOk(() => {
                    let url = `${ConfigManager.getWebSofinUrl()}/editinfo?return_url=${this.$route.path.substring(1,this.$route.path.length)}`
                    window.location.replace(url);
                });
                this.modalController.confirmModal.onClickCancel(() => {
                    this.$router.back();
                });
            } else {
                this.initialSurprisebox();
            }
        },
        //#endregion mixin function
        initialSurprisebox: async function() {
            this.campaignId = this.$route.params.campaignId;
            this.campaign = await this.getCampaignDetail(this.campaignId);
            let msg = null
            let showModal = false
            //Check expire date.
            if (this.campaign.currentDate > this.campaign.expireDate) {
                showModal = true
                msg = this.campaign.type == CampaignType.Buy ? this.lbl.redeem_button.campaignExpiredBuy : this.lbl.surprise.campaignExpired;
            }
            console.log('msg', msg)

            console.log('this.profile.updated_points.points', this.profile)

            if (this.campaign.pointPerUnit > this.profile.updated_points.points) {
                if (this.campaign.pointType && this.campaign.pointType != 'use') {
                    //Get point, do nothing.
                } else {
                    showModal = true
                    msg = this.lbl.surprise.notEnoughPoint;
                }
            }

            //Handle common case for custom text.
            if (!this.campaign.isConditionPass) {
                showModal = true
                //Use api text message.
                switch (this.campaign.conditionAlertId) {
                    case 1:
                        //Campaign is soldout.
                        msg = this.type == CampaignType.Buy ? this.lbl.redeem_button.soldOutBuy : this.lbl.surprise.soldOut;
                        break;
                    case 2:
                        //User already redeem to maximun per person.
                        msg = this.lbl.surprise.maxPerPerson;
                        break;
                    case 3:
                        //Campaign is on cooldown.
                        msg = this.lbl.surprise.redeemCoolDown;
                        break;
                    case 1403:
                        //Campaign is on condition.
                        msg = this.lbl.surprise.condition;
                        break;
                    default:
                        //Other case.
                        msg = this.campaign.conditionAlert;
                        break;
                }
            }
            console.log('showModal', showModal)

            if(showModal) {
                this.alertModal.clearModal()
                    .setShowLogo(true)
                    .setMsg(msg)
                    .show();
                this.alertModal.onClickClose(() => {
                    this.$router.push('/home')
                })
            }

            if (this.$route.query.verifycode) {
                this.campaignVerifyCodeId = this.$route.query.verifycode;
                this.campaignVerifyCode = await this.getCampaignDetail(this.campaignVerifyCodeId);
                if (this.campaignVerifyCode.type == 26) {
                    let isCheckPoint = this.checkPoint();
                    if (isCheckPoint) {
                        this.openVerifyCode();
                    }
                }
            }
        },
        clickCondition: function() {
            this.conditionText = Util.newLineToBr(this.campaign.condition);
            this.alertConditionModal.clearModal()
                    .setTitle("เงื่อนไขกิจกรรม")
                    .setMsg(this.conditionText)
                    .setShowLogo(false)
                    .show();
        },
        openBox: function() {
            this.userLevel = new UserLevel();
            let level = this.userLevel.getLevelVerifiedlaserno();
            if (!level) {
                this.modalController.confirmModal
                                    .clearModal()
                                    .setTag('verifiedlaserno')
                                    .setMsg(this.lbl.verify_laser_id.before_redeem)
                                    .setBtnOk(this.lbl.verify_laser_id.confirm_btn)
                                    .show()
                this.modalController.confirmModal.onClickOk(() => {
                    let url = `${ConfigManager.getWebSofinUrl()}/editinfo?return_url=${this.$route.path.substring(1,this.$route.path.length)}`
                    window.location.replace(url);
                });
            } else if(this.$route.query.verifycode) {
                if (this.campaignVerifyCode.type == 26) {
                    this.surpriseApi();
                }
            } else {
                this.surpriseApi();
            }

        },
        surpriseApi: function() {
            this.loadingModal.show();
            let fortuneName = this.$route.params.fortunename;
            fortuneName = fortuneName.split("_");
            fortuneName = fortuneName[1]
            SurpriseApi.apiGetSurpriseBox(fortuneName).subscribe({
                next: (data) => {
                    this.step = 2
                    console.log(data);
                    this.loadingModal.hide();

                    this.dataSurprisrBox = data.data.result
                    if(data.data.result) {
                        this.redeemKey = data.data.result.RedeemKey;
                    }

                    setTimeout(()=> {
                        this.step = 3
                        this.openSurpriseModal(data.data)
                    },5000);
                },
                error: (err) => {
                    this.loadingModal.hide();
                    this.errorApi(err);
                }
            });
        },
        openSurpriseModal: async function(data){
            if(!data) return;
            if(data.result == null) {
                this.confirmSurpriseModal
                        .clearModal()
                        .setTag('surprise-full')
                        // .setPoint(result.Points)
                        .setBtnOk('ตกลง')
                        .show();
                this.confirmSurpriseModal.onClickOk((data) =>{
                    console.log(data)
                    this.$router.push('/home')
                });
            } else {
                let type = data.status.toLowerCase();
                let result = data.result;

                console.log('type', type);

                if(type == 'points'){
                    this.confirmSurpriseModal
                        .clearModal()
                        .setTag('surprise-point')
                        .setPoint(result.Points)
                        .setBtnOk('ตกลง')
                        .show();

                    this.confirmSurpriseModal.onClickOk((data) =>{
                        console.log(data)
                        this.AccountStore.methods.setUpdatePoint(this.dataSurprisrBox.buzzebees.updated_points);
                        this.$router.push('/home')
                    });
                    this.confirmSurpriseModal.onClickCancel((data) =>{
                        console.log(data)
                    });

                }else if(type == 'campaign'){
                    this.campaignId = result.CampaignId;
                    this.loadingModal.show();
                    const campaign = await this.getCampaignDetail(this.campaignId);
                    this.dataSurprisrBox.FullImageUrl = campaign.fullImageUrl;
                    this.dataSurprisrBox.condition = campaign.condition;

                    this.loadingModal.hide();
                    this.openConfirmSurprise(campaign);

                }else if(type == 'lose'){
                    this.confirmSurpriseModal
                        .clearModal()
                        .setTag('surprise-full')
                        .setBtnOk('ตกลง')
                        .show();

                }
            }
        },
        getCampaignDetail: function (campaignId) {
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .setRedeemMedia('fortunewheel')
                .create();

            return new Promise((resolve, reject) => {
                BzbsCampaign.apiGetCampaignDetail(this.campaignConfig).subscribe((campaign) => {
                    console.log(campaign)
                    resolve(campaign);
                }, (err) => {
                    reject(err);
                });
            });

        },
        openConfirmSurprise: function(campaign){
            console.log('campaign', campaign)
            if(campaign.delivered){
                this.confirmSurpriseModal
                    .clearModal()
                    .setTag('surprise-campaign-delivery')
                    .setCampaign(campaign)
                    .setBtnOk(this.lbl.surprise.btn_success_confirm)
                    .setBtnCancel(this.lbl.surprise.btn_success_cancel)
                    .show();

                this.confirmSurpriseModal.onClickOk((data) =>{
                    console.log(data)
                    this.openShipping();
                });
                this.confirmSurpriseModal.onClickCancel((data) =>{
                    console.log(data)
                });

            }else{
                this.confirmSurpriseModal
                    .clearModal()
                    .setTag('surprise-campaign')
                    .setCampaign(campaign)
                    .setBtnOk(this.lbl.surprise.pre_campagin_btnok)
                    .show();

                this.confirmSurpriseModal.onClickOk((data) =>{
                    console.log(data)
                    this.openSerial(campaign);
                });
                this.confirmSurpriseModal.onClickCancel((data) =>{
                    console.log(data)
                    this.$router.push('/reward')
                });
            }
        },
        openSerial: function(campaign) {
            let purchase = new CampaignModel(this.dataSurprisrBox);
            let serial = new SerialModel();
            serial.setModelFromDataModel(purchase);
            this.modalController.serialModal
                .setType('surprise-box')
                .setSerial(serial)
                .show();
            this.modalController.serialModal.onClickShowCondition(() => {
                this.alertModal.clearModal()
                    .setType('surprise-box')
                    .setMsg(this.dataSurprisrBox.condition)
                    .setShowLogo(false)
                    .setCampaign(campaign)
                    .show();
                this.alertModal.onClickClose(() => {
                    this.modalController.serialModal
                        .show()
                })
            });
            this.modalController.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
            });
        },
        openShipping: function() {
            this.shippingAddressModal
                        .clearModal()
                        .setTitle(this.lbl.shipping.surprise_box)
                        .setType('surprise-box')
                        .show();
            this.shippingAddressModal.onSaveAddress(address => {
                this.saveAddressApi(address)
            });
        },
        saveAddressApi: function(address) {
            this.loadingModal.show();
            this.redeemConfigBuilder.redeemShippingAddressConfigBuilder = address;
            let params = this.redeemConfigBuilder.getRedeemParams();

            BzbsAddressList.apiAddAddress(params).subscribe((data) => {
                this.loadingModal.hide();
                console.log(data);
                this.updateShipping(data)
            }, (err) => {
                this.loadingModal.hide();
                console.log(err);
            });
        },
        updateShipping: function(address){
            let redeemAddressConfig = null;

            redeemAddressConfig = {
                addressKey: address.RowKey,
                updateCampaignSerial: true
            };
            this.loadingModal.show();
            let token = Account.getToken();
            BzbsAddress.apiUpdateAddressAfterRedeem(token, this.redeemKey, redeemAddressConfig)
                .subscribe(() => {
                    this.loadingModal.hide();
                    this.confirmSurpriseModal
                        .clearModal()
                        .setTag('surprise-campaign-delivery-success')
                        .setBtnOk(this.lbl.surprise.btn_history)
                        .show();
                    this.confirmSurpriseModal.onClickOk((data) =>{
                        console.log(data)
                        this.$router.push('/history')
                    });

                }, () => {
                    this.loadingModal.hide();
                });
        },
        clickBack: function() {
            this.$router.push('/home')
        },
        checkPoint: function() {
            if(this.profile.updated_points.points < this.campaignVerifyCode.pointPerUnit){
                this.confirmSurpriseModal
                    .clearModal()
                    .setTag('check-point')
                    // .setPoint(result.Points)
                    .setBtnOk('ตกลง')
                    .show();
                this.confirmSurpriseModal.onClickOk((data) =>{
                    console.log(data)
                    this.$router.back()
                });
                return false;
            }else{
                return true;
            }
        },
        openVerifyCode: function() {
            console.log('Verifycode')
            this.isVerifyCode = true;
            this.verifyCodeModal
                .setTitle('กรุณากรอกโค้ดเพื่อร่วมสนุก')
                .setCampaignId(this.campaignVerifyCode.id)
                .setBtnOk('ตกลง')
                .show()
            this.verifyCodeModal.onClickCancel(() =>{
                this.$router.back()
            });
            this.verifyCodeModal.onClickCondition(() =>{
                // console.log('clickCondition')
                this.showConditon();
            });
        },
        showConditon: function() {
            this.conditionText = Util.newLineToBr(this.campaignVerifyCode.condition);
            this.alertConditionModal.clearModal()
                .setTitle('เงื่อนไขการร่วมสนุก')
                .setMsg(this.conditionText)
                .setShowLogo(false)
                .show();
            this.alertConditionModal.onClickClose(() => {
                this.openVerifyCode();
            })
        }
    },
}
</script>
<style lang="scss" scoped>
    .position-condition{
        top: 46%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
